module.exports = __webpack_public_path__ + "924a4d9d4473bbcc35d6c8aff4fa30e6.pdf";